// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"81ecf792","138":"d845acc1","261":"06934132","306":"307b1aa5","313":"35d02ea5","389":"96819065","677":"e8813f93","765":"307b1aa5"}[chunkId] + ".chunk.css";
};